const TR_IBAN_LENGTH = 26;
/** Boşlukları atar, büyük harfe çevirir. */
export function normalizeIban(value) {
    return value.replace(/\s+/g, "").toUpperCase();
}
/** ISO 13616 mod 97 denetimi (ülkeden bağımsız). */
function passesMod97(iban) {
    const rearranged = iban.slice(4) + iban.slice(0, 4);
    let remainder = 0;
    for (const char of rearranged) {
        const code = char.charCodeAt(0);
        // Harfler A=10 … Z=35 olarak iki haneye açılır; kalan adım adım hesaplanır (büyük sayı gerekmez).
        const chunk = code >= 65 && code <= 90 ? String(code - 55) : char;
        for (const digit of chunk)
            remainder = (remainder * 10 + Number(digit)) % 97;
    }
    return remainder === 1;
}
/** Türkiye IBAN'ı: TR + 2 kontrol + 5 banka kodu + 1 rezerv (0) + 16 hesap = 26 karakter. */
export function isValidTrIban(value) {
    const iban = normalizeIban(value);
    if (iban.length !== TR_IBAN_LENGTH || !/^TR\d{24}$/.test(iban))
        return false;
    if (iban[9] !== "0")
        return false;
    // Kontrol basamakları 02–98 aralığındadır (ISO 13616): geçerli basamak 97 olan hesapta "00" da mod 97'den geçer.
    const checkDigits = Number(iban.slice(2, 4));
    if (checkDigits < 2 || checkDigits > 98)
        return false;
    return passesMod97(iban);
}
/** "TR33 0006 1005 1978 6457 8413 26" */
export function formatIban(value) {
    return normalizeIban(value)
        .replace(/(.{4})/g, "$1 ")
        .trim();
}
/** Log ve ekranlar için maskeleme (KVKK): "TR33 **** **** **** **** **13 26" */
export function maskIban(value) {
    const iban = normalizeIban(value);
    if (iban.length < 8)
        return "****";
    const masked = iban.slice(0, 4) + "*".repeat(iban.length - 8) + iban.slice(-4);
    return masked.replace(/(.{4})/g, "$1 ").trim();
}
//# sourceMappingURL=iban.js.map